import { render, staticRenderFns } from "./MainTableThree.vue?vue&type=template&id=b8f511dc&scoped=true&"
import script from "./MainTableThree.vue?vue&type=script&lang=js&"
export * from "./MainTableThree.vue?vue&type=script&lang=js&"
import style0 from "./MainTableThree.vue?vue&type=style&index=0&id=b8f511dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f511dc",
  null
  
)

export default component.exports